import type { ConnectionQuality } from "livekit-client";

export const CONNECTION_QUALITY: Record<ConnectionQuality, number> =
  Object.freeze({
    excellent: 5,
    good: 3,
    poor: 1,
    lost: 0,
    unknown: 5,
  });
